"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var EMPTY_REF = '@@__EMPTY_REF__@@';

function useLazyRef(initializer) {
  var ref = (0, _react.useRef)(EMPTY_REF);

  if (ref.current === EMPTY_REF) {
    ref.current = initializer();
  }

  return ref;
}

__signature__(useLazyRef, "useRef{ref}");

var _default = useLazyRef;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(EMPTY_REF, "EMPTY_REF", "/builds/bA1zbJom/0/gojob/ui-bits/src/hooks/useLazyRef.ts");
  reactHotLoader.register(useLazyRef, "useLazyRef", "/builds/bA1zbJom/0/gojob/ui-bits/src/hooks/useLazyRef.ts");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/hooks/useLazyRef.ts");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ob29rcy91c2VMYXp5UmVmLnRzIl0sIm5hbWVzIjpbIkVNUFRZX1JFRiIsInVzZUxhenlSZWYiLCJpbml0aWFsaXplciIsInJlZiIsImN1cnJlbnQiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7Ozs7Ozs7Ozs7QUFFQSxJQUFNQSxTQUFjLEdBQUcsbUJBQXZCOztBQUVBLFNBQVNDLFVBQVQsQ0FBdUJDLFdBQXZCLEVBQTZDO0FBQzNDLE1BQU1DLEdBQUcsR0FBRyxtQkFBVUgsU0FBVixDQUFaOztBQUNBLE1BQUlHLEdBQUcsQ0FBQ0MsT0FBSixLQUFnQkosU0FBcEIsRUFBK0I7QUFDN0JHLElBQUFBLEdBQUcsQ0FBQ0MsT0FBSixHQUFjRixXQUFXLEVBQXpCO0FBQ0Q7O0FBQ0QsU0FBT0MsR0FBUDtBQUNEOztjQU5RRixVOztlQVFNQSxVOzs7Ozs7Ozs7Ozs7MEJBVlRELFM7MEJBRUdDLFUiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyB1c2VSZWYgfSBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IEVNUFRZX1JFRjogYW55ID0gJ0BAX19FTVBUWV9SRUZfX0BAJztcblxuZnVuY3Rpb24gdXNlTGF6eVJlZjxUPihpbml0aWFsaXplcjogKCkgPT4gVCkge1xuICBjb25zdCByZWYgPSB1c2VSZWY8VD4oRU1QVFlfUkVGKTtcbiAgaWYgKHJlZi5jdXJyZW50ID09PSBFTVBUWV9SRUYpIHtcbiAgICByZWYuY3VycmVudCA9IGluaXRpYWxpemVyKCk7XG4gIH1cbiAgcmV0dXJuIHJlZjtcbn1cblxuZXhwb3J0IGRlZmF1bHQgdXNlTGF6eVJlZjtcbiJdfQ==